const defaultExportSettings = {
  HasIdColumn: true,
  HasExternalIdColumn: true,
  HasTaskNameColumn: true,
  HasTaskTypeColumn: true,
  HasAssetNameColumn: true,
  HasAssetClassColumn: true,
  HasAssetAddressColumn: true,
  HasAssetDescriptionColumn: true,
  HasDepartmentColumn: true,
  HasEmployeesColumn: true,
  HasDescriptionColumn: true,
  HasStatusColumn: true,
  HasClosingCodeColumn: true,
  HasCreatedColumn: true,
  HasFactStartColumn: true,
  HasStartColumn: true,
  HasFinishColumn: true,
  HasFactFinishColumn: true,
  HasPriorityColumn: true,
  HasPlannedOperationColumns: true,
  HasActualOperationColumns: true,
  HasIntervalColumn: true
};

export default defaultExportSettings;
